import React from 'react';
import styled, {css} from 'styled-components';

interface WrapperProps {
  children: React.ReactNode;
  className?: string;
  isAccess?: boolean;
}

interface StyledWrapperProps {
  isAccess: boolean;
}

const StyledWrapper = styled.div <StyledWrapperProps>`
  position: relative;
  margin: 0 auto;
  padding: var(--distance-m) var(--distance-l);
  max-width: var(--max-width-s);

  ${({ isAccess }) =>
    !isAccess && css`
      padding-top: var(--distance-4xl);
      background-color: var(--color-accent-background);
    `
    }
`;

const StyledContent = styled.div`
  position: relative;
  z-index: 2;
`;

const Wrapper = ({ children, className, isAccess = false } : WrapperProps) => {
  return (
    <StyledWrapper isAccess={isAccess} className={className}>
      <StyledContent>
        {children}
      </StyledContent>
    </StyledWrapper>
  );
};

export default Wrapper;
